import { AppLayout } from '@layouts/app-layout/AppLayout';
import { LearningRouter } from '@pages/learning/LearningRouter';
import { OverviewPage } from '@pages/overview/OverviewPage';
import { PilotScheduleRouterPage } from '@pages/pilot-schedule/PilotScheduleRouterPage';
import { PrecheckinRouterPage } from '@pages/pre-checkin/PrecheckinRouterPage';
import { TrainingContentLibraryRouterPage } from '@pages/training-content-library/TrainingContentLibraryRouterPage';
import { AuthenticatedRoute } from '@shared/components/route-guards/authenticated-route/AuthenticatedRoute';
import { FeatureFlagGuard } from '@shared/components/route-guards/feature-flag-guard/FeatureFlagGuard';
import { ModuleGuard } from '@shared/components/route-guards/module-guard/ModuleGuard';
import { PermissionGuard } from '@shared/components/route-guards/permission-guard/PermissionGuard';
import { RouteObject } from 'react-router-dom';

import { APP_ROUTES } from './routes.constants';

/**
 * Train module routes - for Trainees
 * Base path: /train
 *
 * Guard stack:
 * 1. AuthenticatedRoute - User must be logged in
 * 2. ModuleGuard - User must have Train module access
 */
export const trainRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.TRAIN_BASE,
    element: (
      <AuthenticatedRoute>
        <ModuleGuard />
      </AuthenticatedRoute>
    ),
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: APP_ROUTES.TRAIN_OVERVIEW,
            element: <OverviewPage />,
          },
          {
            path: APP_ROUTES.TRAIN_PILOT_SCHEDULE + '/*',
            element: (
              <AuthenticatedRoute>
                <PilotScheduleRouterPage />
              </AuthenticatedRoute>
            ),
          },
          {
            path: APP_ROUTES.TRAIN_LIBRARY + '/*',
            element: (
              <AuthenticatedRoute>
                <PermissionGuard permission="MyLearning_View_Own">
                  <TrainingContentLibraryRouterPage />
                </PermissionGuard>
              </AuthenticatedRoute>
            ),
          },
          {
            path: APP_ROUTES.TRAIN_RESERVATIONS + '/*',
            element: (
              <PermissionGuard permission="MyLearning_View_Own">
                <LearningRouter />
              </PermissionGuard>
            ),
          },
          {
            path: 'checkin/:trainingId/*',
            element: (
              <AuthenticatedRoute>
                <FeatureFlagGuard flag="precheckinMfeEnabled">
                  <PermissionGuard permission="ModuleTrain_View_Any">
                    <PrecheckinRouterPage />
                  </PermissionGuard>
                </FeatureFlagGuard>
              </AuthenticatedRoute>
            ),
          },
        ],
      },
    ],
  },
];
